import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { STORAGE_KEYS, UserRole } from '../constants/app-constants';

/** Allow pass-through routes even when subscription is inactive */
const SUBSCRIPTION_FREE_ROUTES = ['/subscription', '/profile', '/change-password', '/notifications'];

export const subscriptionGuard: CanActivateChildFn = (_route, state) => {
  const storage = inject(StorageService);
  const router = inject(Router);

  // Staff and super admin users don't need subscription
  const role = storage.get(STORAGE_KEYS.USER_ROLE);
  if (role === UserRole.STAFF || role === UserRole.SUPER_ADMIN) return true;

  const isActive = storage.get(STORAGE_KEYS.SUBSCRIPTION_ACTIVE) !== 'false';
  if (isActive) return true;

  const url = state.url.split('?')[0]; // strip query params
  const isFree = SUBSCRIPTION_FREE_ROUTES.some((r) => url === r || url.startsWith(r + '/'));
  if (isFree) return true;

  router.navigate(['/subscription']);
  return false;
};
